import { cloneDeep } from 'lodash';
import ReactDataSheet from 'react-datasheet';

import { IGridElement, IRowValidation, ISheetHeaders } from '../../types';
import { validateDuplicateRows } from './validateDuplicateRows';
import { validateRegex } from './validateRegex';
import { validationMessages } from './validationMessages';

export const handleCellChanges = (
  changes: ReactDataSheet.CellsChangedArgs<IGridElement, string>,
  grid: IGridElement[][],
  headers: ISheetHeaders,
  validation: IRowValidation[]
) => {
  const changedGrid = cloneDeep(grid);
  const changedValidation = cloneDeep(validation);
  changes.forEach(({ cell, row, col, value }) => {
    let error;
    const validationRegex = headers[col].validation;
    const canceller = validation[row].cancel;
    if (canceller) {
      canceller();
    }
    changedValidation[row] = {
      validating: false,
      cancel: undefined,
      messages: [],
    };
    if (value && validationRegex && !validateRegex(value, validationRegex)) {
      const validationMessage =
        headers[col].validationMessage ||
        `Value not matching pattern: ${validationRegex}`;
      error = validationMessage;
      changedValidation[row] = {
        validating: false,
        messages: [validationMessages.VALIDATION],
      };
    }
    let finalValue = value;
    if (cell && cell.isTargetUrl && finalValue) {
      if (!finalValue.match(/http(s)?:\/\//)) {
        finalValue = `https://${finalValue}`;
      }
    }
    changedGrid[row][col] = {
      ...changedGrid[row][col],
      value: finalValue,
      error,
    };
  });
  const newValidation = validateDuplicateRows(changedGrid, changedValidation);
  return {
    grid: changedGrid,
    validation: newValidation,
  };
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/handleCellChanges.ts